import React from 'react';
import { graphql } from 'gatsby';
import LayoutContainer from '../../containers/layout';
import SEO from '../../components/seo';
import './index.scss';
import GetInvolvedContainer from '../../components/GetInvolved/getInvolvedContainer';

export const query = graphql`
  query GISEOQuery {
    allSanitySeoSchema(filter: { PageSlug: { eq: "get-involved-page" } }) {
      edges {
        node {
          SEOSchema
          PageSlug
        }
      }
    }
    site: sanitySiteSettings(_id: { regex: "siteSettings/" }) {
      title
      description
      keywords
    }
  }
`;
const GetInvolvedPage = (props) => {
  const getInvolvedPageSchema = JSON.parse(props.data.allSanitySeoSchema.edges[0].node.SEOSchema);

  const { data } = props;
  const { site } = data || {};
  return (
    <LayoutContainer>
      <SEO title={`${site.title} | Contact Us`} description={site.description} keywords={site.keywords} schemaMarkup={getInvolvedPageSchema} />
      <GetInvolvedContainer />
    </LayoutContainer>
  );
};
export default GetInvolvedPage;
